import {type NonEmptyArray} from '@freckle/non-empty'
import {toFragment} from '@frontrow/console/src/entities/helpers/routers/query-params'

import {type FilterT} from '@frontrow/console/src/components/common/data-table'
import {createDatatableUrl} from '@frontrow/console/src/helpers/data-table'

export const Routes = {
  home: () => '/',
  teachers: {
    teachers: () => '/teachers',
    teacherLicenses: (teacherId: number) => `/teachers/${teacherId}/licenses`
  },
  idpOverlayStudents: () => '/idp-overlay-students',
  login: () => '/login',
  students: () => '/students',
  schools: {
    schools: () => '/schools',
    schoolEdit: (schoolId: number) => `/schools/${schoolId}/edit`,
    bulkEditSchoolConfiguration: (schoolIds: NonEmptyArray<number>, filters: Array<FilterT>) => {
      return toFragment(createDatatableUrl('/schools/edit/batch', {filters}), {
        schoolIds: schoolIds.join(',')
      })
    },
    schoolLicenses: (schoolId: number) => `/schools/${schoolId}/licenses`
  },
  districts: {
    districts: () => '/districts',
    districtLicenses: (districtId: number) => `/districts/${districtId}/licenses`,
    rgpCsvs: (districtId: number, schoolId?: number) =>
      `/districts/${districtId}/rgp-csvs/${schoolId ?? ''}`
  },
  schoolAdmins: {
    schoolAdmins: () => '/school-admins'
  },
  roster: () => '/roster',
  rosterSync: () => '/roster-sync',
  importSisIds: () => '/import-sis-ids',
  items: {
    items: () => '/items',
    itemEdit: (itemId: number) => `/items/${itemId}/edit`,
    itemCreate: () => '/items/create'
  },
  piggyStore: () => '/piggy-store',
  demoDistrict: () => '/demo-district',
  salesReports: () => '/sales-reports',
  standardSets: () => '/standard-sets',
  jobs: () => '/jobs'
}
